import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d358b04c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-background" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "app-shell-container py-12" }

import Sidebar from "./DashboardSidebar.vue";
// Legacy ESLint does not detect script-setup components used in the template.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import DashboardModuleSidebar from "./DashboardModuleSidebar.vue";
import Loader from "@/components/common/Loader.vue";
import WebSocket from "@/layout/WebSocket.vue";
import AssistantChatWidget from "@/components/assistant/AssistantChatWidget.vue";
import { store } from "@/store";
import { LoaderGetters } from "@/store/modules/loader";
import { useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { LayoutDataService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutTemplates = ref<any[]>([]);
const hasSections = ref(false);
const sectionsOpen = ref(false);

onMounted(async () => {
  const response = await LayoutDataService.get();
  layoutTemplates.value = Object.values(response.data.data);
});

const route = useRoute();
const loader = computed(() => {
  return store.getters[LoaderGetters.GET_LOADER];
});

const key = computed(() => {
  return route.path + Math.random();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(loader))
          ? (_openBlock(), _createBlock(Loader, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(Sidebar, {
      templates: layoutTemplates.value,
      "has-sections": hasSections.value,
      "sections-open": sectionsOpen.value,
      onToggleSections: _cache[0] || (_cache[0] = ($event: any) => (sectionsOpen.value = !sectionsOpen.value))
    }, null, 8, ["templates", "has-sections", "sections-open"]),
    _createVNode(DashboardModuleSidebar, {
      templates: layoutTemplates.value,
      "mobile-expanded": sectionsOpen.value,
      "onUpdate:mobile-expanded": _cache[1] || (_cache[1] = ($event: any) => ((sectionsOpen).value = $event)),
      onAvailability: _cache[2] || (_cache[2] = ($event: any) => (hasSections.value = $event))
    }, null, 8, ["templates", "mobile-expanded"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view, { key: _unref(key) }),
          _createVNode(WebSocket),
          _createVNode(AssistantChatWidget)
        ])
      ])
    ])
  ]))
}
}

})